import {DevicesState} from '../state/devices.state';
import {
  Actions,
  DEVICE_CREATED,
  DEVICE_DELETED, DEVICE_FETCHED,
  DEVICE_UPDATED,
  DEVICES_USER_FETCHED,
} from '../actions/devices.actions';
import {Device} from '../../shared/models/device';

const initialState: DevicesState = {
  devices: [],
};

export function DevicesReducer(state: DevicesState = initialState, action: Actions): DevicesState {
  let devices: Device[];

  switch (action.type) {
    case DEVICE_FETCHED:
      devices = state.devices.filter((d) => {
        return d.ID !== action.device.ID;
      });

      devices.push(action.device);

      return {
        ...state,
        devices: devices,
      };
    case DEVICES_USER_FETCHED:
      return {
        ...state,
        devices: action.devices,
      };
    case DEVICE_CREATED:
      devices = [...state.devices, action.device];

      return {
        ...state,
        devices: devices,
      };
    case DEVICE_UPDATED:
      devices = state.devices.map((d) => {
        if (d.ID !== action.device.ID) {
          return d;
        } else {
          return action.device;
        }
      });

      return {
        ...state,
        devices: devices,
      };
    case DEVICE_DELETED:
      devices = state.devices.filter((d) => {
        return d.ID !== action.deviceId;
      });

      return {
        ...state,
        devices: devices,
      };
    default:
      return state;
  }
}
